<template>
  <div id="staffPerformanceList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>路侧数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>员工绩效查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="changeCust"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备账号::">
            <el-select v-model="pageSearch.fDevAccID"
                       clearable
                       filterable
                       placeholder="请选择设备"
                       style="width:200px;">
              <el-option v-for="item in devacc_list"
                         :key="item.fDevAccID"
                         :label="item.fDevAccNo+':'+item.fLinkman"
                         :value="item.fDevAccID">
                <!-- <span style="float: left">{{ item.fDevAccNo }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fLinkman }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:150px"
                            type="date"
                            :clearable="false"
                            format="yyyy-MM-dd"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:150px"
                            format="yyyy-MM-dd"
                            :clearable="false"
                            type="date"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  :summary-method="getSummaries"
                  ref="dt"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fDevAccNo"
                           label="设备账号">
          </el-table-column>
          <el-table-column prop="fLinkman"
                           label="联系人">
          </el-table-column>
          <el-table-column prop="fStartTime"
                           width="160"
                           label="起始时间">
          </el-table-column>
          <el-table-column prop="fEndTime"
                           width="160"
                           label="结束时间">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           align="right"
                           label="计费金额">
          </el-table-column>
          <el-table-column prop="fOuterName"
                           label="支付方式">
          </el-table-column>
          <el-table-column prop="fCounts"
                           align="right"
                           label="数量">
          </el-table-column>
          <el-table-column prop="fPayAmount"
                           align="right"
                           label="支付金额">
          </el-table-column>
          <!-- <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="80">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { report as api } from '../../../api/roadSideReport'
import * as park from '../../../api/park'
import * as user from '../../../api/user'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      devacc_list: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      fendTime: '',
      sumTip: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fDevAccID: '',
        fstartTime: '',
        fendTime: ''
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    getSummaries (param) {
      var sums = []
      sums[0] = '合计'
      sums[1] = this.sumTip
      var num = $('.el-table__footer tr td').length
      if (num > 2) {
        $('.el-table__footer tr td:gt(1)').remove()
        $('.el-table__footer tr td:eq(1)').attr('colspan', num - 1)
        $('.el-table__footer tr td:eq(1)').css('text-align', 'right')
      }
      return sums
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fstartTime = this.startTime
      if (this.startTime instanceof Date) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      }
      this.pageSearch.fendTime = this.endTime
      if (this.endTime instanceof Date) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      }
      this.sumTip = ''
      api.staffPerformanceList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
            this.sumTip = data.Data.sumTip
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      api.staffPerformanceExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_员工绩效数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    changeCust (fCustID) {
      this.pageSearch.fDevAccID = ''
      this.devacc_list = []
      if (fCustID) {
        api.pdaList({ fCustID: fCustID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.devacc_list = data.Data || []
            } else {
              this.$message.error('提示：加载设备账号列表失败')
            }
          }
        })
      }
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
            if (this.cust_list.length > 0) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.changeCust(this.cust_list[0].fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    // handleInfo (index, row) {
    //   this.dialogFormVisible = true
    //   this.usrExgData.loading = false

    //   this.dialogTitle = ((row.fParkName || '').trim(), length <= 0 ? '' : ('【' + row.fParkName + '】')) + '交班明细数据' + '（' + row.fOuterName.split('】')[1] + '）'
    //   this.userExgSearch.fCustID = row.fCustID
    //   this.userExgSearch.fExgID = row.fExgID
    //   this.userExgSearch.type = row.fBigRowID

    //   this.usrExgData.fOpLastTime = row.fOpLastTime
    //   this.usrExgData.fUserName = row.fUserName
    //   this.usrExgData.fBatStartTime = row.fBatStartTime
    //   this.usrExgData.fBatEndTime = row.fBatEndTime
    //   this.usrExgData.fParkName = row.fParkName
    //   this.usrExgData.fBigRowID = '0'
    //   this.usrExgData.fCustName = ''
    //   this.cust_his_data = []
    //   this.usr_exg_data = []
    //   this.pay_data = []
    //   this.cust_his_data_count = 0
    //   api.handoverInfo({ fCustID: row.fCustID, fExgID: row.fExgID }).then(res => {
    //     if (res && res.data) {
    //       var data = res.data
    //       if (data.IsOk) {
    //         this.usr_exg_data = data.Data || []
    //         if (this.usr_exg_data.length > 0) {
    //           if ((this.usr_exg_data[0].fCustName || '').trim().length > 0) {
    //             this.dialogTitle = '【' + this.usr_exg_data[0].fCustName + '】交班明细数据'
    //             this.usrExgData.fCustName = this.usr_exg_data[0].fCustName
    //           }
    //         }
    //       } else {
    //         this.$message.error('提示：' + data.Msg)
    //       }
    //     }
    //   })
    //   this.page_exg_list()
    // },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    }
  },
  created () {
    var today = new Date()
    // var yesterday = new Date(today.getTime())
    // yesterday = new Date(yesterday.setDate(today.getDate() - 1))
    // var tomorrow = new Date(today.getTime())
    // tomorrow = new Date(tomorrow.setDate(today.getDate() + 1))
    this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    user.getCurrentUserPers({ perTypeId: 130000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#staffPerformanceList .el-dialog {
  min-width: 840px;
}
#staffPerformanceList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#staffPerformanceList .el-dialog__title {
  color: white;
}
#staffPerformanceList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#staffPerformanceList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#staffPerformanceList .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#staffPerformanceList .el-input.is-disabled .el-input__inner,
#staffPerformanceList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#staffPerformanceList .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#staffPerformanceList .el-input__icon {
  line-height: 32px;
}
#staffPerformanceList .warning-row {
  color: #337ab7;
}
/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.title-row {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/report/staffPerformanceList.vue